import React, {Component} from "react"
import {injectIntl} from 'react-intl'
import $ from 'jquery'
import Formsy from 'formsy-react'
import {ComponentMixin} from 'formsy-react-components'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css'
import moment from 'moment'

const BirthMonthPicker = React.createClass({
  displayName: 'BirthMonthPicker',
  mixins: [Formsy.Mixin, ComponentMixin],

  getInitialState () {
    return {
    };
  },

  componentWillReceiveProps: function(nextProps) {

    if(nextProps.value && nextProps.value !== this.state.value){

      const date = moment(nextProps.value, 'MMYYYY')
      this.setState({value:nextProps.value})

      $('.birthmonthpicker').datepicker('destroy')

      $('.birthmonthpicker').datepicker({
        minViewMode: 1,
        autoclose: true,
        format: 'MMM yyyy',
        forceParse: false,
        defaultViewDate:{
          year: date.year(),
          month: date.month(),
          day: 1
        }
      }).on('changeDate', function (e) {

        var value = moment(e.date).format('MMYYYY');
        this.setValue(value);
        this.setState({value});
        this.props.onChange(value);

      }.bind(this))
    }


  },

  componentDidMount: function () {

    const date = moment(this.props.value, 'MMYYYY')

    this.setState({value: this.props.value})

    $('.birthmonthpicker').datepicker({
      minViewMode: 1,
      autoclose: true,
      format: 'MMM yyyy',
      forceParse: false,
      defaultViewDate:{
        year: date.year(),
        month: date.month(),
        day: 1
      }
    }).on('changeDate', function (e) {

      var value = moment(e.date).format('MMYYYY');
      this.setValue(value);
      this.setState({value});
      this.props.onChange(value);

    }.bind(this))
  },
  render: function () {

    const format = this.props.intl.formatMessage

    const value = this.state.value? moment(this.state.value, 'MMYYYY').format('MMM YYYY') : ""

    return (
      <input data-provide="datepicker"
             readOnly
             type="text"
             className="form-control datepicker birthmonthpicker"
             placeholder={format({id:'input.placeholder.dob'})}
             value={value}
      ></input>
    )
  }
})

export default injectIntl(BirthMonthPicker)



// WEBPACK FOOTER //
// ./src/components/BirthMonthPicker.js